import React from 'react';
import { ChordCaptainIcon } from './exerciseIcons/ChordCaptainIcon';
import { EqExpertIcon } from './exerciseIcons/EqExpertIcon';
import { GainGuruIcon } from './exerciseIcons/GainGuruIcon';
import { LoopLegendIcon } from './exerciseIcons/LoopLegendIcon';
import { MidSideMarvelIcon } from './exerciseIcons/MidSideMarvelIcon';
import { MixMagicianIcon } from './exerciseIcons/MixMagicianIcon';
import { PanningProIcon } from './exerciseIcons/PanningProIcon';
import { WidthWizardIcon } from './exerciseIcons/WidthWizardIcon';

const ExerciseIcon = ({ iconId }) => {
   switch (iconId) {
      case 'chord-captain': {
         return <ChordCaptainIcon />;
      }
      case 'gain-guru': {
         return <GainGuruIcon />;
      }
      case 'panning-pro': {
         return <PanningProIcon />;
      }
      case 'mix-magician': {
         return <MixMagicianIcon />;
      }
      case 'eq-expert': {
         return <EqExpertIcon />;
      }
      case 'loop-legend': {
         return <LoopLegendIcon />;
      }
      case 'width-wizard': {
         return <WidthWizardIcon />;
      }
      case 'mid-side-marvel': {
         return <MidSideMarvelIcon />;
      }
      default: {
         return null;
      }
   }
};

export { ExerciseIcon };
